import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const state = {
  sidebarShow: "responsive",
  sidebarMinimize: false,

  // currentComponent: "",
  // currentConsultaId: null,
};

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
  // setCurrentComponent(state, component) {
  //   state.currentComponent = component;
  // },
  // setCurrentConsultaId(state, id) {
  //   state.currentConsultaId = id;
  // },
};

const actions = {
  setValue({ commit }, value) {
    commit("setValue", value);
  },
  // setCurrentComponent({ commit }, component) {
  //   commit("setCurrentComponent", component);
  // },
  // setCurrentConsultaId({ commit }, id) {
  //   commit("setCurrentConsultaId", id);
  // },
};
export default new Vuex.Store({
  // plugins: [
  //   createPersistedState({
  //     paths: ["currentConsultaId"],
  //   }),
  // ],

  state,
  mutations,
  actions,
});
